import {useLocation} from 'react-router-dom';

import useScrollTop from './useScrollTop';

export const useHistoryScrollTop = () => {
    const {pathname} = useLocation();

    useScrollTop([pathname]);
};

export default useHistoryScrollTop;
